import { html } from 'lit';
import { daysTo } from '../../../utils/date';
import { t } from 'i18next';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { isEmpty } from '../../../utils/stringUtils';
export const GiveFeedback = ({ giveFeedbackUrl, tradeId, expiryDate, name }) => {
    const giveFeedbackUrlParsed = giveFeedbackUrl && tradeId
        ? giveFeedbackUrl.replace('{{tradeId}}', `${tradeId}`)
        : undefined;
    return html `
    <p class="mb-8 strong">Hvordan var det å handle med ${!isEmpty(name) ? name : t('Anonumous user')}?</p>
    <p class="detail">${unsafeHTML(t('Days left', {
        count: daysTo(new Date(expiryDate)),
    }))}</p>
    <trust-button
      primary
      href=${giveFeedbackUrlParsed}
      classNames="mt-16 min-w-full"
    >
      ${t('Give your evaluation')}
    </trust-button>
  `;
};
//# sourceMappingURL=GiveFeedback.js.map